<template>
    <div class="locale-changer ">
        <select v-model="$i18n.locale" v-on:change="$emit('is-changed');updateLanguagePreference($event.target.value)">
            <option v-for="(lang, i) in langs" :key="`Lang.country${i}`" :value="lang.country">
                {{ lang.label }}
            </option>
        </select>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import axios from 'axios'

    export default {
        name: 'locale-changer',
        props: {
        },
        data() {
            return {
                langs: [
                    {
                        country: 'en',
                        label: 'English'
                    },
                    {
                        country: 'nl',
                        label: 'Nederlands'
                    },
                    {
                        country: 'fr',
                        label: "Français"
                    },

                ]
            }
        },
        methods: {
			updateLanguagePreference: function (newValue) {
				if (this.isLoggedIn) {
					//Post new preference so server
					axios.post('/dashboard/updateLanguagePreference', newValue, {
						headers: { 'content-type': 'application/json' }
					})
						.then(() => {
							//if (response.status == 200) {

       //                         if (response.data != "OK") {
       //                             console.log('Error while updating language preference.');
       //                         } else {
							//		console.log('Language preference updated');
							//	}
							//}
						})
						.catch(function (error) {
							alert(error);
						}
						);
				}
            },
        },
        computed: {
			...mapState([
				'isLoggedIn'
			])
        },
        
         
    }
</script>